<table class="table-compare">
  @for (row of defaultDataTable(); track iRow; let iRow = $index) {
  <tr>
    <!-- NOTE First col -->
    <th>{{ row.header }}</th>
    @for (product of productData(); track iCol; let iCol = $index) {
    <td>
      @if(row.isImg){ @if(row.isBrandLogo){
      <!-- Img Brand -->
      <img
        class="img-brand"
        [src]="replaceBucket.replaceBucket(product[row.fillContent])"
        alt="product-icon"
        title="product-icon"
        loading="lazy"
      />
      } @else {
      <!-- Img Product -->
      <div class="img-product">
        <img [src]="replaceBucket.replaceBucket(product[row.fillContent])" alt="product-icon" title="product-icon" loading="lazy" />
        <button class="btn-delete" (click)="btnDeleteClick(product.id)">X</button>
      </div>
      } } @if(row.addComma){ @if (row.isPrice) {
      <!-- Price -->
      {{ product[row.fillContent] | number }}&nbsp;บาท } @else {
      <!-- Score Number -->
      {{ product[row.fillContent] | number }}
      } } @if(!row.addComma && !row.isPrice && !row.isImg) {
      <!-- Normal Text -->
      {{ product[row.fillContent] }}
      } @if(row.isSummary){
      <button class="btn-detail themeDetailButton1" mat-flat-button (click)="btnDetailClick(product.id)">ดูรายละเอียด</button>
      }
    </td>
    }
  </tr>
  }
</table>
